export const EmptyChevron = () => <></>
